import join from './join'

const nombres = ({ primerNombre, otrosNombres }) => join([primerNombre, otrosNombres])

export default nombres
